import { render, staticRenderFns } from "./auto-logout.vue?vue&type=template&id=54853eba&scoped=true&"
import script from "./auto-logout.vue?vue&type=script&lang=js&"
export * from "./auto-logout.vue?vue&type=script&lang=js&"
import style0 from "./auto-logout.vue?vue&type=style&index=0&id=54853eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54853eba",
  null
  
)

export default component.exports